import secondsToMinutes from "./secondsToMinutes";

export default (seconds) => secondsToMinutes(seconds) > 0 ? secondsToMinutes(seconds) + " Min" : seconds + " Sec"
